import {getBootstrapDeviceSize} from "./getBootstrapDeviceSize";



export const initTeamNav = () => {
    window.teamCategoryNav = () => {
        return {
            activeTab: 'Alle', // Default active tab
            _deviceSize: getBootstrapDeviceSize(),

            isMobile(){
              return ["sm","xs"].includes(this._deviceSize);
            },

            set deviceSize(size){
                this._deviceSize = size;
            },

            init() {
                // Check if a hash exists in URL, then update the active tab accordingly
                const urlHash = window.location.hash.substring(1);
                const mapQuery = window.location.search.substring(1);
                if (mapQuery) {
                    this.map = true;
                }

                if (urlHash) {
                    this.activeTab = this.capitalizeFirstLetter(urlHash);
                    setTimeout(() => {
                        this.sendEvent();
                    }, 0)

                } else {
                    setTimeout(() => {
                        this.sendEvent();
                    }, 0)
                }
                this.initDeviceSize();


            },
            initDeviceSize(){
                this.deviceSize = getBootstrapDeviceSize();
                window.addEventListener('resize', () => {
                    this.deviceSize = getBootstrapDeviceSize();
                })
            },

            selectTab(tab) {

                if (this.activeTab === tab) return;
                this.activeTab = tab;
                window.location.hash = `#${tab.toLowerCase()}`;
                this.sendEvent();

                setTimeout(() => {
                    let el = window.document.getElementById('teamCards');
                    let elTop = el.getBoundingClientRect().top + window.scrollY;
                    let subnav = document.getElementById("subnavwrapper");
                    let subnavbottom = subnav.getBoundingClientRect().bottom  ||0;

                    let mobile_subnav = document.getElementById("subnavwrapper-mobile");
                    let mobile_subnavbottom = mobile_subnav.getBoundingClientRect().bottom || 0;

                    if(this.isMobile()){
                        if(this.activeTab === "Alle"){
                            window.scrollTo({left:0,top:0,behavior:"smooth"});
                        }else{
                            window.scrollTo({left:0,top:elTop - mobile_subnavbottom - 25,behavior:"smooth"});
                        }
                    } else{
                        if(this.activeTab === "Alle"){
                            window.scrollTo({left:0,top:0,behavior:"smooth"});
                        }else{
                            window.scrollTo({left:0,top:elTop - subnavbottom - 25,behavior:"smooth"});
                        }
                    }




                },300)
            },

            isActive(tab) {
                return this.activeTab === tab;
            },


            sendEvent() {
                this.$dispatch('tabschanged', {selectedTab: this.activeTab}, true);
            },

            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        }
    }

}


export const initTeamCards = () => {

    Alpine.data("teamCards", () => ({
        activeTab: 'Alle', // Default active tab

        init() {
            this.scrollObserve();
            this.initFakeCards();
        },

        initFakeCards(){
            window.addEventListener('resize', () => {
                //this.deviceSize = getBootstrapDeviceSize();

            })
        },

        scrollObserve() {
            const targetElement = this.$el;
            const anotherElementDesktop = document.getElementById('subnavwrapper');
            const anotherElementMobile = document.getElementById('subnavwrapper-mobile');

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                       // anotherElementDesktop.classList.remove('hidden');
                        anotherElementMobile.classList.remove('hidden');
                    } else {
                        //anotherElementDesktop.classList.add('hidden');
                        anotherElementMobile.classList.add('hidden');
                    }
                });
            });

            observer.observe(targetElement);
        },

        tabactive($e) {
            this.activeTab = $e.detail.selectedTab;
            this.$dispatch('showkategorie', {selectedTab: this.activeTab}, true);
        }

    }));


}